import {Theme, createStyles} from '@material-ui/core';

import TeamBackgroundImage from 'src/Assets/Images/team-background.svg';
import {getBlockTitleStyles} from 'src/Components/Home/getBlockTitleStyles';

export const teamBlockStyles = (theme: Theme) =>
	createStyles({
		root: {
			paddingTop: theme.spacing(5),
			[theme.breakpoints.down('xs')]: {
				backgroundColor: theme.palette.common.white,
			},
		},
		title: {
			...getBlockTitleStyles(theme),
			paddingTop: theme.spacing(24),
			paddingBottom: theme.spacing(2),
			[theme.breakpoints.down('sm')]: {
				paddingTop: theme.spacing(12),
			},
			[theme.breakpoints.down('xs')]: {
				fontSize: theme.typography.pxToRem(15),
				lineHeight: theme.typography.pxToRem(18),
				paddingTop: theme.spacing(0),
				paddingBottom: theme.spacing(1),
			},
		},
		subTitle: {
			fontSize: theme.typography.pxToRem(18),
			lineHeight: theme.typography.pxToRem(26),
			whiteSpace: 'pre-line',
			[theme.breakpoints.down('xs')]: {
				fontSize: theme.typography.pxToRem(11),
				lineHeight: theme.typography.pxToRem(18),
			},
			[theme.breakpoints.down('md')]: {
				marginBottom: theme.typography.pxToRem(26),
			},
		},
		container: {
			[theme.breakpoints.up('sm')]: {
				backgroundImage: `url(${TeamBackgroundImage})`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'right center',
			},
			[theme.breakpoints.down('xs')]: {
				paddingTop: theme.spacing(7),
				paddingBottom: theme.spacing(7),
			},
		},
	});
